<template>
  <q-page padding>
    <report-loader :report-id="reportId" v-model="report" />
    <report-posts
      v-if="report"
      :report-id="reportId"
      style="margin-top: 3rem"
      @trashed="modified"
      @restored="modified"
    />
    <q-page-sticky v-if="report" expand position="top">
      <report-toolbar
        :report="report"
        class="fit bg-white shadow-1"
      />
    </q-page-sticky>
  </q-page>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import moment from 'moment';
import { Report } from '@/type';
import eventBus from '@/messaging/event-bus';
import { ReportPostCommentEdited } from '@/messaging/events';
import { name } from '@/client/client-filter';
import ReportToolbar from './ReportToolbar.vue';
import ReportPosts from './post/ReportPosts.vue';
import ReportLoader from './ReportLoader.vue';

interface Data {
  report: Report|null,
}

export default defineComponent({
  meta() {
    return {
      // @ts-ignore
      title: `${this.pageTitle}`,
    };
  },
  components: {
    ReportLoader,
    ReportToolbar,
    ReportPosts,
  },
  props: {
    reportId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      report: null,
    };
  },
  computed: {
    pageTitle(): string {
      return (this.report) ? `${name(this.report.client)} Report` : 'Report';
    },
  },
  methods: {
    modified() {
      if (this.report) {
        this.report.lastModified = moment().format();
      }
    },
  },
  created() {
    eventBus.$on(ReportPostCommentEdited.eventName, this.modified);
  },
  beforeUnmount() {
    eventBus.$off(ReportPostCommentEdited.eventName, this.modified);
  },
});
</script>
